// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6kC4B","rootMobile":"styles_rootMobile__2DqYw"};